import React from 'react';
import PropTypes from 'prop-types';
import AppService from '../service/AppService';
import WebMediaQuery from './WebMediaQuery';
import AppConfigService from '../service/AppConfigService';

export default class NavBarItem extends React.Component {

  static propTypes = {
    title: PropTypes.any.isRequired,
    shortTitle: PropTypes.any,
    icon: PropTypes.string,
    url: PropTypes.string,
    openOnNewTab: PropTypes.bool,
    showExternalLink: PropTypes.bool,
    className: PropTypes.string,
    onMouseOver: PropTypes.func,
    disabled: PropTypes.bool,
  };

  constructor(props) {
    super(props);

    this.state = {
      showSubMenu: true,
    }
  }

  onMouseOver(e) {
    if (!this.props.disabled && this.props.onMouseOver) {
      this.props.onMouseOver();
      e.preventDefault();
    }
  }

  render() {

    let {
      title,
      shortTitle,
      imageUrl,
      url,
      className,
      icon,
      openOnNewTab,
      showExternalLink,
      disabled,
    } = this.props;

    let {
      showSubMenu
    } = this.state;

    let display = 'none';
    if (showSubMenu) {
      display = 'block';
    }

    let selectedShortTitle = shortTitle?shortTitle:title;

    let href =  AppConfigService.getHref();
    let selected = href.startsWith(url);

    return (
      <div onMouseOver={::this.onMouseOver}>
        <a className={`naviLink ${className?className:''} ${selected?'selected':''} ${disabled?'aw-disabled':''}`}
           href={disabled?'#':url}
           target={openOnNewTab?'_blank':'_self'}>
          {icon && <div className={`naviLinkLogo ${icon}`} />}
          <WebMediaQuery desktopOnly={true}>
            {title}
          </WebMediaQuery>
          <WebMediaQuery mobileOnly={true}>
            {selectedShortTitle}
          </WebMediaQuery>
          {showExternalLink && <div className="external-link" />}
        </a>
      </div>
    )
  }

}